import React, { useContext } from 'react';
import { Box, Grid, Typography } from '@mui/material';
import {
  SparkForm,
  SparkTextField,
  SparkFormResetButton,
  SparkFormButton,
  SparkFormToggleSwitch,
} from 'sharedComponents/SparkForm';
import * as yup from 'yup';
import { useConfirmPassword } from 'hooks/auth';
import { useApplicationUserByID } from 'hooks/ApplicationUser';
import { Cookies } from 'react-cookie';

type PasswordFormValues = {
  VerifyCurrentPassword: string;
  NewPassword: string;
  ConfirmNewPassword: string;
};

function SecurityInfoForm() {
  const passwordInitialValues = {
    VerifyCurrentPassword: '',
    NewPassword: '',
    ConfirmNewPassword: '',
  };
  const cookies = new Cookies();
  const userID = cookies.get('userID') as string;

  const { applicationUser } = useApplicationUserByID(userID);
  const passwordValidationSchema = yup.object({
    VerifyCurrentPassword: yup
      .string()
      .required('Current Password is Required'),
    NewPassword: yup.string().required('New Password is Required'),
    ConfirmNewPassword: yup
      .string()
      .required('Password is Required again')
      .oneOf([yup.ref('NewPassword')], 'Passwords must match'),
  });

  const { mutateAsync: changePassword } = useConfirmPassword();

  const handlePassword = (values: PasswordFormValues) => {
    changePassword({
      email: applicationUser?.attributes?.email,
      password: values.NewPassword,
      confirmPassword: values.ConfirmNewPassword,
    });
  };

  return (
    <Grid container marginTop={2}>
      <Typography
        variant='h5'
        sx={{
          fontFamily: 'Mont-semibold',
        }}
      >
        Password
      </Typography>

      <Box
        width='100%'
        bgcolor='white'
        borderRadius='20px'
        border={(theme) => `1px solid ${theme.palette.borderColor}`}
      >
        <SparkForm<PasswordFormValues>
          initialValues={passwordInitialValues}
          onSave={handlePassword}
          validationSchema={passwordValidationSchema}
          containerProps={{ spacing: 2, padding: 2 }}
        >
          <Grid display='flex' flexDirection='column' width='100%' margin={2}>
            <SparkTextField
              name='VerifyCurrentPassword'
              label='Verify current password'
              type='password'
              placeholder='Enter your current password'
            />
            <SparkTextField
              name='NewPassword'
              label='Enter New Password'
              type='password'
              placeholder='Enter your new password'
            />
            <SparkTextField
              name='ConfirmNewPassword'
              label='Confirm New Password'
              type='password'
              placeholder='Enter your new password again'
            />
          </Grid>

          <Grid
            item
            xs={12}
            sx={{ display: 'flex', justifyContent: 'flex-end' }}
          >
            <Grid
              item
              container
              xs={12}
              gap={2}
              justifyContent='flex-end'
              flexWrap='nowrap'
            >
              <SparkFormResetButton
                variant='outlined'
                sx={{ width: '200px', padding: '10px 20px', marginTop: '10px' }}
              >
                Cancel
              </SparkFormResetButton>
              <SparkFormButton
                sx={{ width: '200px', padding: '10px 20px', marginTop: '10px' }}
              >
                Save
              </SparkFormButton>
            </Grid>
          </Grid>
        </SparkForm>
      </Box>
    </Grid>
  );
}

export default SecurityInfoForm;
